const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.5373f7525e952dd6794ceed6788b2fb5.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.e2b3f3be2ded8b334f248e77e41478a2.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.58ebe506b2ffbcf975e9147f7d5fbfe6.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.575cdd684fb3556e4bc542654e6dbeea.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.8512fe5783e73b549b0d2fb25e986af3.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.8b7f98c7cf460e18e3bc6582738e1573.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.accea9090f7f5132e8837ae24cedf130.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.319c4f215805d92735d276ef7385de1a.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.313a77586049605c8ff8f58a12ff1a3a.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.36c8257e442e492c33809be945f78b9b.min.css',
        versioned: 'standard-tile.min.css'
    },
    standardHero: {
        hashed: 'standard-hero.32135ffdcc958612fb508a80994ec7cd.min.css',
        versioned: 'standard-hero.min.css'
    },
    standardBanner: {
        hashed: 'standard-banner.f1445b8b9d462a33605fe6d081dd0878.min.css',
        versioned: 'standard-banner.min.css'
    },
    spinner: {
        hashed: 'spinner.577f2755aed546aea2a5d6e093ad4923.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.ecd247e5804fa5a41b991b8466e0da06.min.css',
        versioned: 'selection-set.min.css'
    },
    secondaryTile: {
        hashed: 'secondary-tile.bcc65db02f3bdb65dc89b2c4dcd31ec0.min.css',
        versioned: 'secondary-tile.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.303c7a25956758f27fbca2c7d7dd5db1.min.css',
        versioned: 'ratings-stars.min.css'
    },
    promoBar: {
        hashed: 'promo-bar.cb76b61d102ab8348fd90625377fef59.min.css',
        versioned: 'promo-bar.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.6b81465261734a1d69c413ae0d1de54c.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.53dd6c06b13cb44d0bdca37c4d0f21a5.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.689cea7e3eba9f9c0940542cb61ed7b0.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.1d2b6a53bfb3b9e7ded0a4f9cf167554.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.784f87acf82ba6d53fc0f096f7692d75.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.b4f924be801a80f2d06de7e2fac8f310.min.css',
        versioned: 'modal-dialog.min.css'
    },
    listbox: {
        hashed: 'listbox.9b932ead934d5a2a7403d71b05673d91.min.css',
        versioned: 'listbox.min.css'
    },
    legacyPopover: {
        hashed: 'legacy-popover.3e19c7c8304802c29cdcdd17c766a0ae.min.css',
        versioned: 'legacy-popover.min.css'
    },
    legacyModalDialog: {
        hashed: 'legacy-modal-dialog.19acb285c70c1b3327fa3e578bfca147.min.css',
        versioned: 'legacy-modal-dialog.min.css'
    },
    legacyListbox: {
        hashed: 'legacy-listbox.0da95b49931114ca3fb39c091fce9d3f.min.css',
        versioned: 'legacy-listbox.min.css'
    },
    legacyCombobox: {
        hashed: 'legacy-combobox.94fd8fab4d7863fe37e3da190db10518.min.css',
        versioned: 'legacy-combobox.min.css'
    },
    icon: {
        hashed: 'icon.eb5c777db42e5cc9ce1e03ab8bf69980.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.cf3e6718c3a005e721d90e2297c95d54.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.48cc7fb1febcf653dc6008d63393a402.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.5f8e8f66a61903f3a42030497226611c.min.css',
        versioned: 'field-set.min.css'
    },
    embeddedTextHero: {
        hashed: 'embedded-text-hero.4de75b200d53852f2e6ef67f8d8edc4b.min.css',
        versioned: 'embedded-text-hero.min.css'
    },
    detailsBanner: {
        hashed: 'details-banner.cee6ed65ad5ec1a7a188bc886b0e02fa.min.css',
        versioned: 'details-banner.min.css'
    },
    controlIcon: {
        hashed: 'control-icon.107485af736c953d20f01dea06910bec.min.css',
        versioned: 'control-icon.min.css'
    },
    combobox: {
        hashed: 'combobox.da3248b7fe67fd776520c534565c97d1.min.css',
        versioned: 'combobox.min.css'
    },
    carousel: {
        hashed: 'carousel.2a3f9b7b00d7c360bbfffad103d0826a.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.5e1e7b82463aa5aabc07f40c87963807.min.css',
        versioned: 'button.min.css'
    },
    alertBox: {
        hashed: 'alert-box.8410c3531033dc281c2e0b5e258a3f4e.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.dfdf85698c19a7730cd6e1e56f33470f.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
